import apiClient from './axios.config';
import { API_ENDPOINTS } from '../../constants';

class PermissionsAPI {
    /**
     * Get all permissions
     * @param {Object} params - Query parameters (menu_id, action, include_menu)
     * @returns {Promise<Object>} - Permissions data
     */
    async getAllPermissions(params = {}) {
        try {
            const response = await apiClient.get(API_ENDPOINTS.PERMISSIONS_NEW, { params });
            return response.data;
        } catch (error) {
            console.error('Get all permissions error:', error);
            throw error;
        }
    }

    /**
     * Get permissions for a specific menu
     * @param {number} menuId - Menu ID
     * @returns {Promise<Object>} - Menu permissions
     */
    async getMenuPermissions(menuId) {
        try {
            const response = await apiClient.get(API_ENDPOINTS.PERMISSIONS_BY_MENU(menuId));
            return response.data;
        } catch (error) {
            console.error('Get menu permissions error:', error);
            throw error;
        }
    }

    /**
     * Get role permissions in tree structure
     * @param {number} roleId - Role ID
     * @returns {Promise<Object>} - Role permissions tree
     */
    async getRolePermissions(roleId) {
        try {
            const response = await apiClient.get(API_ENDPOINTS.PERMISSIONS_BY_ROLE(roleId), {
                params: { _t: Date.now() },
            });
            return response.data;
        } catch (error) {
            console.error('Get role permissions error:', error);
            throw error;
        }
    }

    /**
     * Update role permissions
     * @param {number} roleId - Role ID
     * @param {Object} data - Permission data (permission_ids array)
     * @returns {Promise<Object>} - Update result
     */
    async updateRolePermissions(roleId, data) {
        try {
            const response = await apiClient.put(API_ENDPOINTS.PERMISSIONS_UPDATE_ROLE(roleId), data);
            return response.data;
        } catch (error) {
            console.error('Update role permissions error:', error);
            throw error;
        }
    }

    /**
     * Create permissions for a menu
     * @param {number} menuId - Menu ID
     * @param {Object} data - Permission data (actions array)
     * @returns {Promise<Object>} - Created permissions
     */
    async createMenuPermissions(menuId, data) {
        try {
            const response = await apiClient.post(API_ENDPOINTS.PERMISSIONS_CREATE_MENU(menuId), data);
            return response.data;
        } catch (error) {
            console.error('Create menu permissions error:', error);
            throw error;
        }
    }
}

const permissionsAPI = new PermissionsAPI();
export default permissionsAPI;
